import CompaniesDeliveryTab from "@/pages/guest/tabs/CompaniesDeliveryTab.vue";
import IncomeTab from "@/pages/guest/tabs/IncomeTab.vue";
import KorisniciTab from "@/pages/guest/tabs/KorisniciTab.vue";
import MealsTab from "@/pages/guest/tabs/MealsTab.vue";
import NamirniceTab from "@/pages/guest/tabs/NamirniceTab.vue";
import ObrociTab from "@/pages/guest/tabs/ObrociTab.vue";
import RestaurantsTab from "@/pages/guest/tabs/RestaurantsTab.vue";
import TakenTab from "@/pages/guest/tabs/TakenTab.vue";
import AdminCompaniesDeliveryTab from "@/pages/guest/tabs/admin/AdminCompaniesDeliveryTab.vue";
import AdminIncomeTab from "@/pages/guest/tabs/admin/AdminIncomeTab.vue";
import AdminKorisniciTab from "@/pages/guest/tabs/admin/AdminKorisniciTab.vue";
import AdminMealsTab from "@/pages/guest/tabs/admin/AdminMealsTab.vue";
import AdminNamirniceTab from "@/pages/guest/tabs/admin/AdminNamirniceTab.vue";
import AdminObrociTab from "@/pages/guest/tabs/admin/AdminObrociTab.vue";
import AdminRestaurantsTab from "@/pages/guest/tabs/admin/AdminRestaurantsTab.vue";
import AdminTakenTab from "@/pages/guest/tabs/admin/AdminTakenTab.vue";
import GuestIncomeView from "./GuestIncomeView.vue";
import GuestMobileIncomeView from "./mobile/GuestMobileIncomeView.vue";
import GuestMobileMealsView from "./mobile/GuestMobileMealsView.vue";
import GuestMobileOrderSheet from "./mobile/GuestMobileOrderSheet.vue";
import GuestMobileTakenView from "./mobile/GuestMobileTakenView.vue";
import GuestMobileUsersView from "./mobile/GuestMobileUsersView.vue";
import GuestMobileOrdersView from "./mobile/GuestMobileOrdersView.vue";
import GuestOrdersView from "./GuestOrdersView.vue";
import GuestMealsView from "./GuestMealsView.vue";
import GuestTakenView from "./GuestTakenView.vue";
import hasGuestOrderPanel from "./hasGuestOrderPanel";
import { createGuestScreen } from "./screens/createGuestScreen";
import { createOrdersScreen } from "./screens/createOrdersScreen";

// Novi prikazi iznad starih tabova (restoran i admin): isto učitavanje, štampa i Excel kao do sada.
const mealsProps = (vm) => ({ rows: vm.data });
const dishesProps = (vm) => ({ rows: vm.data, showNotes: true });
const takenProps = (vm) => ({ rows: vm.data });
const incomeProps = (vm) => ({ days: vm.data });
const incomeOn = (vm) => ({ "open-order": ({ order, guest, event }) => vm.openOrder(order, guest, event) });

const GuestOrders = createOrdersScreen({ name: "GuestDesktopOrders", view: GuestOrdersView });
const GuestOrdersAdmin = createOrdersScreen({ name: "GuestDesktopOrdersAdmin", admin: true, view: GuestOrdersView });
const GuestMobileOrders = createOrdersScreen({ name: "GuestMobileOrders", view: GuestMobileOrdersView, panel: GuestMobileOrderSheet });
const GuestMobileOrdersAdmin = createOrdersScreen({ name: "GuestMobileOrdersAdmin", admin: true, view: GuestMobileOrdersView, panel: GuestMobileOrderSheet });
// Isti stari tabovi, prikaz za telefon (kartice umesto tabele).
const mobileScreen = (name, base, view, viewProps, extra = {}) =>
  createGuestScreen({ name, base, view, viewProps, ...extra });
const GuestMobileMeals = mobileScreen("GuestMobileMeals", ObrociTab, GuestMobileMealsView, mealsProps);
const GuestMobileMealsAdmin = mobileScreen("GuestMobileMealsAdmin", AdminObrociTab, GuestMobileMealsView, mealsProps, { loadOnMount: true });
const GuestMobileDishes = mobileScreen("GuestMobileDishes", MealsTab, GuestMobileMealsView, dishesProps);
const GuestMobileDishesAdmin = mobileScreen("GuestMobileDishesAdmin", AdminMealsTab, GuestMobileMealsView, dishesProps, { loadOnMount: true });
const GuestMobileTaken = mobileScreen("GuestMobileTaken", TakenTab, GuestMobileTakenView, takenProps);
const GuestMobileTakenAdmin = mobileScreen("GuestMobileTakenAdmin", AdminTakenTab, GuestMobileTakenView, takenProps, { loadOnMount: true });
const mobileIncome = { viewOn: incomeOn, mixins: [hasGuestOrderPanel], panel: GuestMobileOrderSheet };
const GuestMobileIncome = mobileScreen("GuestMobileIncome", IncomeTab, GuestMobileIncomeView, incomeProps, mobileIncome);
const GuestMobileIncomeAdmin = mobileScreen("GuestMobileIncomeAdmin", AdminIncomeTab, GuestMobileIncomeView, incomeProps, { ...mobileIncome, loadOnMount: true });

// Korisnici: izbor firme je u prikazu, a stari tab drži spisak firmi i izabranu firmu. Stari admin tab učitava firme
// tek kad se promeni period ili izbor restorana, pa ih ovde učitava i pri otvaranju.
const usersProps = (vm) => ({
  rows: vm.data,
  companies: vm.companies,
  company: vm.selectedCompany,
  loadingCompanies: vm.isLoadingCompanies,
});
const usersOn = (vm) => ({
  "select-company": (name) => {
    vm.selectedCompany = name;
    // admin tab učitava korisnike sam (posmatrač izabrane firme); tab restorana ih učitava na izbor
    if (!(vm.$options.watch && vm.$options.watch.selectedCompany)) {
      vm.loadData();
    }
  },
});
const loadsCompaniesOnMount = {
  mounted() {
    if (this.restaurantIds && typeof this.loadCompanies === "function") {
      this.loadCompanies();
    }
  },
};
const GuestMobileUsers = mobileScreen("GuestMobileUsers", KorisniciTab, GuestMobileUsersView, usersProps, { viewOn: usersOn });
const GuestMobileUsersAdmin = mobileScreen("GuestMobileUsersAdmin", AdminKorisniciTab, GuestMobileUsersView, usersProps, {
  viewOn: usersOn,
  mixins: [loadsCompaniesOnMount],
});

const GuestMeals = createGuestScreen({ name: "GuestDesktopMeals", base: ObrociTab, view: GuestMealsView, viewProps: mealsProps });
const GuestMealsAdmin = createGuestScreen({ name: "GuestDesktopMealsAdmin", base: AdminObrociTab, view: GuestMealsView, viewProps: mealsProps, loadOnMount: true });
const GuestDishes = createGuestScreen({ name: "GuestDesktopDishes", base: MealsTab, view: GuestMealsView, viewProps: dishesProps });
const GuestDishesAdmin = createGuestScreen({ name: "GuestDesktopDishesAdmin", base: AdminMealsTab, view: GuestMealsView, viewProps: dishesProps, loadOnMount: true });
const GuestTaken = createGuestScreen({ name: "GuestDesktopTaken", base: TakenTab, view: GuestTakenView, viewProps: takenProps });
const GuestTakenAdmin = createGuestScreen({ name: "GuestDesktopTakenAdmin", base: AdminTakenTab, view: GuestTakenView, viewProps: takenProps, loadOnMount: true });
const GuestIncome = createGuestScreen({ name: "GuestDesktopIncome", base: IncomeTab, view: GuestIncomeView, viewProps: incomeProps, viewOn: incomeOn, mixins: [hasGuestOrderPanel] });
const GuestIncomeAdmin = createGuestScreen({ name: "GuestDesktopIncomeAdmin", base: AdminIncomeTab, view: GuestIncomeView, viewProps: incomeProps, viewOn: incomeOn, mixins: [hasGuestOrderPanel], loadOnMount: true });

export const ROLE_ADMIN = "admin";
export const ROLE_RESTAURANT = "restaurant";
/** Nalog "report_guest": samo narudžbe */
export const ROLE_GUEST = "guest";

/** Uloga izveštaja prema tipu korisnika (sve osim admina i restorana je nalog "report_guest"). */
export const roleOf = (userType) =>
  userType === ROLE_ADMIN ? ROLE_ADMIN : userType === ROLE_RESTAURANT ? ROLE_RESTAURANT : ROLE_GUEST;

/**
 * Izveštaji gostiju. Svaki ekran je ili novi (narudžbe, prihodi, obroci, jela, preuzeto) ili stari tab u
 * novoj ljusci (legacy), a admin ima svoje varijante (više restorana). Na telefonu su isti ekrani
 * u prikazu kartica; korisnici, namirnice, firme i restorani su stari tabovi (već imaju prikaz za telefon).
 *   restaurants: ekran se odnosi na izabrane restorane (admin)
 *   legacy:      stari tab (svoje učitavanje, štampa, Excel)
 *   filters:     ekran ima filtere koji nisu u traci (vrsta isporuke)
 */
export const buildGuestScreens = (t, role, { mobile = false } = {}) => {
  const admin = role === ROLE_ADMIN;
  const screens = {
    orders: {
      title: t("guests"),
      subtitle: t("guest_desktop.hints.orders"),
      icon: "mdi-cart-outline",
      component: mobile ? (admin ? GuestMobileOrdersAdmin : GuestMobileOrders) : admin ? GuestOrdersAdmin : GuestOrders,
      restaurants: admin,
      filters: true,
      live: true,
    },
    income: {
      title: t("income"),
      subtitle: t("guest_desktop.hints.income"),
      icon: "mdi-cash-multiple",
      component: admin ? GuestIncomeAdmin : GuestIncome,
      restaurants: admin,
    },
    users: {
      title: t("users"),
      subtitle: t("guest_desktop.hints.users"),
      icon: "mdi-account-group-outline",
      component: admin ? AdminKorisniciTab : KorisniciTab,
      restaurants: admin,
      legacy: true,
    },
    meals: {
      title: t("meals"),
      subtitle: t("guest_desktop.hints.meals"),
      icon: "mdi-silverware-fork-knife",
      component: admin ? GuestMealsAdmin : GuestMeals,
      restaurants: admin,
    },
    dishes: {
      title: t("routes.jela"),
      subtitle: t("guest_desktop.hints.dishes"),
      icon: "mdi-food-outline",
      component: admin ? GuestDishesAdmin : GuestDishes,
      restaurants: admin,
    },
    groceries: {
      title: t("groceri"),
      subtitle: t("guest_desktop.hints.groceries"),
      icon: "mdi-leaf",
      component: admin ? AdminNamirniceTab : NamirniceTab,
      restaurants: admin,
      legacy: true,
    },
    taken: {
      title: t("taken"),
      subtitle: t("guest_desktop.hints.taken"),
      icon: "mdi-truck-outline",
      component: admin ? GuestTakenAdmin : GuestTaken,
      restaurants: admin,
    },
    delivery: {
      title: t("companies_delivery"),
      subtitle: t("guest_desktop.hints.delivery"),
      icon: "mdi-truck-delivery-outline",
      component: admin ? AdminCompaniesDeliveryTab : CompaniesDeliveryTab,
      restaurants: admin,
      legacy: true,
    },
    restaurants: {
      title: t("restaurants"),
      subtitle: t("guest_desktop.hints.restaurants"),
      icon: "mdi-storefront-outline",
      component: admin ? AdminRestaurantsTab : RestaurantsTab,
      restaurants: admin,
      legacy: true,
    },
  };
  if (mobile) {
    // na telefonu isti ekrani, prikaz kao kartice (namirnice, firme i restorani ostaju stari tabovi)
    screens.income = { ...screens.income, component: admin ? GuestMobileIncomeAdmin : GuestMobileIncome, legacy: false };
    screens.meals = { ...screens.meals, component: admin ? GuestMobileMealsAdmin : GuestMobileMeals, legacy: false };
    screens.dishes = { ...screens.dishes, component: admin ? GuestMobileDishesAdmin : GuestMobileDishes, legacy: false };
    screens.taken = { ...screens.taken, component: admin ? GuestMobileTakenAdmin : GuestMobileTaken, legacy: false };
    screens.users = { ...screens.users, component: admin ? GuestMobileUsersAdmin : GuestMobileUsers, legacy: false };
  }
  return screens;
};

/** Grupe navigacije: [{ key, title, items: [ključevi izveštaja] }] */
export const buildGuestMenu = (t, role) => {
  const group = (key, title, items) => ({ key, title, items });
  if (role === ROLE_GUEST) {
    return [group("sales", "", ["orders"])];
  }
  return [
    group("sales", t("guest_desktop.groups.sales"), ["orders", "income", "users"]),
    group("kitchen", t("report_mobile.groups.kitchen"), ["meals", "dishes", "groceries"]),
    group("handout", t("report_mobile.groups.handout"), ["taken", "delivery"]),
    group("other", t("report_mobile.groups.other"), ["restaurants"]),
  ];
};

export const DEFAULT_GUEST_SCREEN = "orders";
